import React from 'react';

type Props = {
  children: React.ReactNode,
}

const ModalFooter = (props: Props) => {
  const { children } = props;

  return (
    <div className="modal-footer">
      {children}
    </div>
  );
};

export default ModalFooter;
